import { Label } from "design-system/atoms/Label"
import { Textarea } from "design-system/atoms/Textarea"
import { useTranslation } from "react-i18next"

type Props = {
  organizationPhoneNumbers: string | null
  setOrganizationPhoneNumbers: (phones: string) => void
}

export const CapabilityOrganizationPhoneNumbers = ({
  organizationPhoneNumbers,
  setOrganizationPhoneNumbers,
}: Props) => {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-1.5">
      <Label>{t(`capabilities.catalog.organizationConfig.phoneNumbers.title`)}</Label>
      <Textarea
        value={organizationPhoneNumbers ?? ""}
        onChange={(ev) => setOrganizationPhoneNumbers(ev.target.value)}
        placeholder={t(`capabilities.catalog.organizationConfig.phoneNumbers.placeholder`)}
      />
      <span className="text-muted-foreground">
        {t(`capabilities.catalog.organizationConfig.phoneNumbers.description`)}
      </span>
    </div>
  )
}
